import { Color } from 'three';

/**
 * Resolve background color from various formats
 */
export const resolveBackgroundColor = (color: string | undefined, container: HTMLElement): Color => {
	if (!color) {
		return new Color('white');
	}

	// Handle CSS variables
	if (color.startsWith('var(')) {
		const style = getComputedStyle(container);
		const resolved = style.backgroundColor || 'white';

		if (resolved.startsWith('var(') || !resolved || resolved === 'rgba(0, 0, 0, 0)') {
			return new Color('white');
		}

		return new Color(resolved);
	}

	return new Color(color);
};
